import React from 'react'
import TopBannerSlider from './TopBannerSlider/TopBannerSlider'
import TopBannerOne from './TopBannerSlider/TopBannerOne'

const TopBaner = ({inPlaySlidingBanners, auth}) => {

  return (
    <>
      {inPlaySlidingBanners.length>1?
        <TopBannerSlider inPlaySlidingBanners={inPlaySlidingBanners} auth={auth} />
        :
        (inPlaySlidingBanners.length==1)?
        <TopBannerOne inPlaySlidingBanners={inPlaySlidingBanners} auth={auth} />
        :
        null
      }
    </>
  )
}

export default TopBaner
